<ngx-json-ld [json]="schema"></ngx-json-ld>
<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header">
  <div class="page-content-wider">
    <h1 class="offers-header-title">{{ getHeaderTitle() }}</h1>
    <div class="header-description">
      <div id="headerText" [class.collapsed]="!isDescriptionExpanded">
        {{ getHeaderText() }}
      </div>
      <button (click)="toggleDescription()" class="toggle-button">
        <span [ngClass]="{ 'arrow-down': !isDescriptionExpanded, 'arrow-up': isDescriptionExpanded }"></span>
      </button>
    </div>
  </div>
</div>

<div class="page-content-wider">

  <div class="on-sale-modern">
  <div class="store-media-selectors-container">
    <div class="store-media-selectors-content">
      <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
      <app-media-selector class="media-selector-container" [selectedMediaType]="selectedMediaType" [mediaTypes]="mediaTypesForDisplay"
        (onMediaChanged)="mediaChanged($event)">
      </app-media-selector>
    </div>
  </div>

  <app-categories-bar></app-categories-bar>

  <div class="filters-container-test">

    <div class="small-horizontal-border"></div>

    <div class="normal-filters">
      <div class="filters-panel" [class.fp-close]="isFiltersPanelOpen == false">
      <div class="filter-test-mobile-sort">
        <app-dropdown class="dd-test" [label]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [default]="sortValues[0]" [right]="true" (onItemSelected)="sortChanged(listType, $event)"></app-dropdown>
      </div>
      <div *ngIf="sortKey=='greatestSavings'" class="filter-test sort-period-filter-mobile">
        <app-dropdown class="dd-test" [label]="getString('period')" [items]="sortPeriodValues" [selectedItem]="sortPeriodKey" [right]="true" (onItemSelected)="sortPeriodChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test">
        <app-multichoice-menu class="dd-test" [title]="getString('genres')" [label]="getString('genres')" [itemList]="genres" [selectedItemsList]="selectedGenres" (selectionChanged)="genreChanged($event)"></app-multichoice-menu>
      </div>
      <div class="filter-test" *ngIf="listType != 'pricefilter' && listType != 'nowfree'">
        <app-slider-multichoice class="dd-test" [title]="getString('priceFilter')" [isPrice]="true" [label]="getString('priceFilter')" [itemList]="priceRanges" [selectedItemsList]="selectedPriceRanges" (selectionChanged)="priceRangeChanged($event)"></app-slider-multichoice>
      </div>
      <div class="filter-test" *ngIf="shouldShowPricePerMovieFilter()">
        <app-slider-multichoice class="dd-test" [title]="getString('pricePerMovie')" [isPrice]="true" [label]="getString('pricePerMovie')" [itemList]="pricePerMovieRanges" [selectedItemsList]="selectedPricePerMovieRanges" (selectionChanged)="pricePerMovieRangeChanged($event)"></app-slider-multichoice>
      </div>
      <div class="filter-test">
        <app-dropdown class="dd-test" [label]="getString('offers')" [items]="offersFilterOptions" [selectedItem]="selectedOffersFilterOption" [default]="listType == 'onsale' ? offersFilterOptions[1] : offersFilterOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="offersFilterChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'movies' && listType != 'bundles'">
        <app-filter-dropdown #movieRatingsDD class="dd-test" [title]="getString('movieRatings')" [label]="getString('movieRatings')" [redText]="getActiveMovieRatingsFilters() != getString('none')" [selection]="movieRatingsSelection" (onReset)="resetMovieRatingsFilters()" (onOpen)="movieRatingsSliders.init()">
          <app-movie-ratings-sliders #movieRatingsSliders [movieRatingsFilters]="movieRatingsFilters" (onApply)="movieRatingsDD.closeDropdown();applyMovieRatingsFilter($event)"></app-movie-ratings-sliders>
        </app-filter-dropdown>
      </div>
      <div class="filter-test" *ngIf="(selectedMediaType == 'seasons') && (isCountry('de') || isCountry('at') || isCountry('ch')) && getStore() == 'itunes'">
        <app-dropdown class="dd-test" [label]="getString('language')" [items]="audiotrackOptions" [selectedItem]="selectedAudiotrackOption" [default]="audiotrackOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="audiotrackChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'movies' || selectedMediaType == 'seasons'">
        <app-dropdown class="dd-test" [label]="getString('quality')" [items]="qualityOptions" [selectedItem]="selectedQuality" [default]="qualityOptions[0]" [stringAttr]="'title'" [right]="true" (onItemSelected)="qualityChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="shouldShowBundleFilter()">
        <app-dropdown class="dd-test" [label]="getString('bundleFilter')" [items]="bundleFilterOptions" [selectedItem]="selectedBundleFilterOption" [default]="bundleFilterOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="bundleFilterChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'music'">
        <app-dropdown class="dd-test" [label]="getString('type')" [items]="musicOptions" [selectedItem]="selectedMusicOption" [default]="musicOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="musicOptionChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'apps' && listType != 'vision-pro-apps'">
        <app-dropdown class= "dd-test" [label]="getString('device')" [items]="getDevices()" [selectedItem]="selectedDevice" [default]="getDevices()[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="deviceChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="listType != 'nowfree' && (selectedMediaType == 'apps' || selectedMediaType == 'macapps')">
        <app-dropdown class="dd-test" [label]="getString('type')" [items]="getPriceTypes()" [selectedItem]="selectedPriceType" [default]="getPriceTypes()[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="priceTypeChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="(selectedMediaType == 'movies' || selectedMediaType == 'seasons') && isCountry('us') && listType != 'bundles'">
        <app-multichoice-menu class="dd-test" [title]="getString('advisoryRating')" [label]="getString('advisoryRating')" [itemList]="advisoryRatings" [selectedItemsList]="selectedAdvisoryRatings" (selectionChanged)="advisoryRatingChanged($event)"></app-multichoice-menu>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'movies' && showBuyRentOption()">
        <app-dropdown class= "dd-test" [label]="getString('type')" [items]="buyRentOptions" [selectedItem]="buyRentSelectedOption" [default]="buyRentOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="buyRentChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="(selectedMediaType == 'movies') && getStore() != 'amazon' && getStore() != 'googlePlay'">
        <app-multichoice-menu class="dd-test" [title]="getString('hdrFormat')" [label]="getString('hdrFormat')" [itemList]="hdrFormatOptions" [selectedItemsList]="selectedHdrFormatOptions" (selectionChanged)="hdrFormatChanged($event)"></app-multichoice-menu>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'movies' && getStore() != 'amazon' && getStore() != 'googlePlay'">
        <app-dropdown class="dd-test" [label]="getString('sound')" [items]="soundOptions" [selectedItem]="selectedSoundOption" [default]="soundOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="soundChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="(selectedMediaType == 'movies') && isCountry('us') && listType != 'bundles'">
        <app-dropdown class="dd-test" [label]="getString('moviesAnywhere')" [items]="moviesAnywhereOptions" [selectedItem]="selectedMAOption" [default]="moviesAnywhereOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="moviesAnywhereChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test" *ngIf="selectedMediaType == 'movies' && listType != 'bundles'">
        <app-multichoice-menu class="dd-test" [title]="getString('studio')" [label]="getString('studio')" [itemList]="studioOptions" [selectedItemsList]="selectedStudioOptions" (selectionChanged)="studioChanged($event)"></app-multichoice-menu>
      </div>
      <div class="filter-test" *ngIf="(selectedMediaType == 'movies') && getStore() == 'itunes'">
        <app-dropdown class="dd-test" [label]="getString('itunesExtra')" [items]="itunesExtrasOptions" [selectedItem]="selectedItunesExtrasOption" [default]="itunesExtrasOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="itunesExtrasChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test">
        <app-slider-year class="dd-test" [title]="getString('year2')"
        [label]="getString('year2')"
        [selectedItemsList]="selectedReleaseYear"
        [constMinValue]="1900"
        [constMaxValue]="currentYear"
        (selectionChanged)="releaseYearChanged($event)"></app-slider-year>
      </div>
      <div class="filter-test" *ngIf="shouldShowRuntimeFilter()">
        <app-slider-runtime class="dd-test" [title]="getString('runtime')"
        [label]="getString('runtime')"
        [selectedItemsList]="selectedRuntime"
        [constMinValue]="1"
        [constMaxValue]="350"
        (selectionChanged)="runtimeChanged($event)"></app-slider-runtime>
      </div>
      <div class="filter-test hide-french-titles-filter" *ngIf="shouldShowFrenchTitlesFilter()">
        <div *ngIf="showHideFrenchTitlesNewFeaturePopup()" class="new-feature-tooltip hide-french-titles-feature-popup">
          <span class="close-btn" (click)="closeHideFrenchTitlesNewFeaturePopup()">&times;</span>
          {{getString('newFeatureHideFrenchTitles')}}
        </div>
        <app-dropdown class="dd-test" [label]="getString('frenchTitles')" [items]="getFrenchTitlesOptions()" [selectedItem]="selectedFrenchTitlesOption" [default]="getFrenchTitlesOptions()[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="frenchTitlesChanged($event)"></app-dropdown>
      </div>
    </div>
    <div *ngIf="selectedMediaType == 'movies' || selectedMediaType == 'seasons' || selectedMediaType == 'apps'" class="more-filters-btn" (click)="toggleFiltersPanel()">
      {{isFiltersPanelOpen ? getString('lessFilters') : getString('moreFilters')}}
    </div>
    </div>

    <div class="special-filter">
      <app-dropdown class="sort float-right dd" [selectedItemWidth]="'180px'" [title]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged(listType, $event)"></app-dropdown>

      <div *ngIf="sortKey=='greatestSavings' || sortKey=='greatestPercentageSavings'" class="sort-period-filter">
        <div *ngIf="showSortPeriodNewFeatureBubble()" class="new-feature-tooltip">
          <span class="close-btn" (click)="closeSortPeriodNewFeatureBubble()">&times;</span>
          {{getString('newFeatureSortPeriod')}}
        </div>
        <app-dropdown class="sort float-right dd" [selectedItemWidth]="'180px'" [title]="getString('period')" [items]="sortPeriodValues" [selectedItem]="sortPeriodKey" [right]="true" (onItemSelected)="sortPeriodChanged($event)"></app-dropdown>
      </div>
    </div>

  </div>
  </div>

  <div class="items-container" *ngIf="showAmazonUSItems()">

    <div class="item-container" *ngFor="let item of items; let i = index;">
      <ng-container *ngIf="!hideBecausePurchased(item)">
        <app-date-separator [mode]="getDateSeparatorMode()" [shouldDisplay]="showDateSeparator(item, i)"
        [date]="getDate(item)"></app-date-separator>
        <app-grid-item [item]="item" [priceHint]="'offerslist'"
          (onItemClicked)="itemClicked($event, item)"
          (onWishlistClicked)="addToWishlist(item)"
          (onOwnlistClicked)="addToOwnlist(item)"
          (onBlocklistClicked)="addToBlocklist(item)"
          (onRemoveFromWishlistClicked)="removeFromWishlist(item)"
          (onRemoveFromOwnlistClicked)="removeFromOwnlist(item)"
        >
      </app-grid-item>
      </ng-container>
    </div>

  </div>

  <div *ngIf="!showAmazonUSItems()" class="center-txt-box">
    {{getString('cantShowAmazonItems')}} <a class="blue-link" [routerLink]="'/' + getCountry() + '/' + getString('contactUrl')">{{getString('contactUs')}}</a>
  </div>

  <div class="not-supported" *ngIf="!mediaSupportedForCountry()">{{getString('mediaNotSuportedForCountry')}}</div>

  <div class="results-end" *ngIf="resultsEndReached && items.length > 0">
    {{getString('endOfResults')}}
  </div>
  <div class="results-end" *ngIf="resultsEndReached && items.length == 0">
    <img class="sad-face" src="./assets/images/sad.png"><br/>
    {{getString('noOffers')}}
  </div>
  <div class="results-end" *ngIf="techError">{{getString('technicalProblems')}}
    <div><button type="button" (click)="reload(false)">{{getString('reload')}}</button></div>
  </div>

  <div *ngIf="listType == 'blackFriday' && getStore() == 'itunes'" class="text-in-box">

      <div class="bf-title">{{getString('blackFridayTitle1')}}</div>
      <div class="bf-text">{{getString('blackFridayText1')}}</div>
    <br>


      <div class="bf-title">{{getString('blackFridayTitle2')}}</div>
      <div class="bf-text">{{getString('blackFridayText2')}}</div>
      <br>


      <div class="bf-title">{{getString('blackFridayTitle3')}}</div>
      <div class="bf-text">{{getString('blackFridayText3')}}</div>
      <br>


      <div class="bf-title">{{getString('blackFridayTitle4')}}</div>
      <div class="bf-text">{{getString('blackFridayText4')}}</div>

  </div>

  <div *ngIf="showSpinner" class="spinner-container txt-algn-cntr">
    <app-spinner></app-spinner>
  </div>

</div>

<app-scroll-top *ngIf="showScrollToTopButton"></app-scroll-top>
